export default {
    SET: 'SET_CLIENT_LAST_VIEWED',
    CLEAR: 'CLEAR_CLIENT_LAST_VIEWED'
}